/**
 * Absolute http(s) URL check — the shape Zoom accepts for a webinar's
 * post-session survey link (settings.survey_url). Mirrors the backend rule.
 */
export const isValidHttpUrl = (value: string): boolean => {
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};
